import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface SettingsState {
  sidebarCollapsed: boolean;
  theme: "light" | "dark";
  language: string;
}

const initialState: SettingsState = {
  sidebarCollapsed: false,
  theme: "light",
  language: "en",
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    setSidebarCollapsed: (state, { payload }: PayloadAction<boolean>) => {
      state.sidebarCollapsed = payload;
    },
    setTheme: (state, { payload }: PayloadAction<"light" | "dark">) => {
      state.theme = payload;
    },
    setLanguage: (state, { payload }: PayloadAction<string>) => {
      state.language = payload;
    },
    resetSettings: () => initialState,
  },
});

export const {
  toggleSidebar,
  setSidebarCollapsed,
  setTheme,
  setLanguage,
  resetSettings,
} = settingsSlice.actions;

export default settingsSlice.reducer;
